import type { ScoreConfig } from './contracts';

/**
 * SPEC-015 T116 / owner approval 2026-09-15.
 * Single V1 configuration shared by the engine, UI and verification.
 */
export const APPROVED_SCORE_CONFIG_V1 = {
  version: '1.0.0',
  approvalId: 'OWNER-2026-09-15-SPEC-015',
  dimensionWeights: {
    acquisition: 0.25,
    conversion: 0.3,
    commercial: 0.25,
    retention: 0.2,
  },
  componentWeights: {
    acquisition: {
      source_diversity: 0.25,
      investment_clarity: 0.25,
      volume: 0.25,
      efficiency: 0.25,
    },
    conversion: {
      rates: 0.3,
      stage_clarity: 0.25,
      consistency: 0.25,
      goals: 0.2,
    },
    commercial: {
      pipeline_representation: 0.3,
      close_efficiency: 0.3,
      follow_up: 0.2,
      goals: 0.2,
    },
    retention: {
      post_sale: 0.25,
      renewal: 0.25,
      upsell: 0.25,
      churn: 0.25,
    },
  },
  minimumDimensionCoverage: 0.5,
  minimumOverallCoverage: 0.5,
} as const satisfies ScoreConfig;
